export default {
	emptyData: '暂无数据',
	add: '8添加',
	delete: '删除',
	query: '查询',
	export: '8导出',
	queryCondition: '8查询条件',
	choose: '8请选择',
	warningTitle: '提示',
	ok: '确定',
	cancel: '取消',
	operate: '操作',
	yes: '8是',
	no: '8否',
	to: '至',
	total: '8共',
	days: '8天',
	day: '天',
	close: '8关闭',
	dateFormat: 'yyyy/MM/dd',
	totalAmount: '8金额合计',
	confirm: {
		delete: '确定要删除吗？',
		export: '导出可能需要较长时间，请等待。（不要关闭页面或重复点击导出按钮）',
		opinion: '驳回必须填写意见/缺陷。',
		sendMail: '您确定要发送催办邮件吗?'
	},
	message: {
		dataEmpty: '表格数据为空，无法导出。',
		deleteSuccess: '删除成功！',
		deleteCancel: '删除已取消',
		exportCancel: '导出已取消',
		up: '已到达查询结果当前页的第一项',
		down: '已到达查询结果当前页的最后一项',
		date: '结束日期不能小于开始日期',
		approvalAgree: '请选择审批同意的单据',
		approvalDisagree: '请选择审批不同意的单据',
		approvalFundsDisagree: '请选择驳回的单据',
		transferSuccess: '转交成功',
		sendSuccess: '发送成功，申请单ID [{0}]',
		recognizeSuccess: '识别成功',
		recognizeFailed: '识别失败',
		exportError: '导出的数据不允许超出2000行，请提高您的搜索精度或联系管理员8001帮助。',
		agreeSuccess: '审批成功',
		saveSuccess: '保存成功',
		submitSuccess: '提交成功',
		dialogError: '弹窗被阻止，请检查你的浏览器设置后重新再试。',
		doneAudit: '该单已被当前用户审批，不能重复操作。',
		tips: '温馨提示'
	},
	warning: {
		tencentCriterion:
			'我已了解并承诺遵守《腾讯阳光行为准则》和报销相关规定的要求，我承诺我提交的报销信息与相关报销单据都是真实且符合公司报销相关规定的。',
		footerDevInfo: '腾讯公司 财经线-S系统财务管理-业务开发中心, 技术支持: IT热线-财经系统支持(8001)'
	},
	tips: { contract: '多个合同号用;分隔', market: '多个活动单号用;分隔', applyPriority: '该申请单的优先级为[高]' },
	status: {
		draft: '草稿',
		processing: '系统处理中',
		relateApprovalAudit: '相关审批人审批',
		businessFinancialAudit: '业务线财管审批',
		businessDeptHeadAudit: '业务部门负责人审批',
		coopDeptHeadAudit: '产业生态合作部负责人审批',
		audited: '审批完成',
		cancelled: '已取消',
		effective: '已完成',
		terminated: '已终止',
		stopped: '已中止',
		deleted: '已删除',
		pendingAcceptance: '待验收',
		acceptance: '已验收',
		vendorConfirm: '供应商确认',
		purchaserConfirm: '采购确认',
		leaderAudit: '直属Leader审批',
		centerChargerAudit: '中心负责人审批',
		priceLibrary: '已进价格库',
		finished: '已完成'
	},
	header: {
		financeLine: '财经线',
		businessProcurementPlatform: '业务采购平台',
		stars: '星辰',
		welcome: '欢迎您，',
		feedback: '意见反馈',
		OAHome: 'OA首页',
		dropOut: '退出'
	}
};
